import { buildStateEvent, GenericStateEvent } from '../../common-redux'
import { Impact } from './model'

export interface ImpactProblemStateEvent<T> extends GenericStateEvent<T> {}

export const GetAllImpactPrioritySuccessEvent = {
    type: 'GetAllImpactPrioritySuccessEvent',
    build: (payload: Impact[]) => buildStateEvent(GetAllImpactPrioritySuccessEvent.type, payload)
}
